module.exports = __webpack_public_path__ + "img/violentFear.e91a1f4d.png";